export default "__VITE_ASSET__fpGHYVeh__"